export const uischema = {
  type: 'VerticalLayout',
  elements: [
    {
      type: 'Control',
      options: {
        customRenderer: 'Icd10',
      },
      label: 'ICD-10 Medical Codes',
      scope: '#/properties/icd10TMedicalCodes',
      enablePrimarySelector: true,
    },
    {
      type: 'Control',
      options: {
        customRenderer: 'Icd10',
      },
      label: 'ICD-10 Treatment Codes',
      scope: '#/properties/icd10TreatmentCodes',
      enablePrimarySelector: false,
    },
  ],
};
